import { useEffect, useRef } from "react";

export const useCurrentValue = <T>(val: T) => {
  const valueRef = useRef<T>(val);

  useEffect(() => {
    valueRef.current = val;
  }, [val]);

  return valueRef;
};
